<template>
  <div
    class="dot-remind-content"
    @click="$_onClick()"
  >
    <i
      v-if="_hasDot"
      class="icon-noti-dot dot-remind-content_dot"
      style="color: #CE3829;"
    />
    <div class="dot-remind-content_content-wrap">
      <div class="dot-remind-content_content-text">
        {{ _title }}
      </div>
      <div class="dot-remind-content_content-date">
        <i
          v-if="_typeIcon"
          class="content-icon"
          :class="_typeIcon"
        />
        <p
          v-if="_date"
          class="content-date"
        >
          {{ _date }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import notificationService from "@/service/api/v1/notification";
import H_time from '@/helpers/time';

export default {
  name: "DotRemindContent",
  props: {
    hasDot: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    typeIcon: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    typeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    _hasDot() {
      return this.data.read_at ? false : true;
    },
    _title() {
      return notificationService.$_getNoticeTitle(this.data);
    },
    _date() {
      return this.$_getTimeFormat(this.data.created_at);
    },
    _typeIcon() {
      const type = this.$_getNoticeType(this.data.data);
      return this.$_getTypeIcon(type);
    },
  },
  methods: {
    $_onClick() {
      this.$emit("remind-click");
    },
    $_getTypeIcon(type) {
      if (this.typeList.length === 0) return '';
      let selectType = this.typeList.find((event) => event.type === type);
      return selectType ? selectType.icon : "";
    },
    $_getNoticeType(notice) {
      if (!notice) return;
      if (notice.type === "ActVersionCreated" || notice.type === "LlCommentUpdated") {
        return "typeg";
      } else if (notice.type === "EventCreated") {
        return "typea";
      } else if (notice.type === "ChecklistRecordCreated") {
        return "typeh";
      } else if (notice.type === "TaskCreated") {
        return "typef";
      } else if (notice.type === "SubTaskCreated") {
        return "typef";
      } else if (notice.type === "SubTaskDone") {
        return "typef";
      } else {
        return "typei";
      }
    },
    $_getTimeFormat(date) {
      if (!date) return '';
      const today = this.$moment().format('YYYY-MM-DD');
      const eventDate = H_time.getDateDashFormat(date);
      let format = 'YYYY-MM-DD HH:mm:ss';
      if (today === eventDate) {
        format = `今天 ${format}`;
      } else if (
        this.$moment(today).subtract(1, 'days').format('YYYY-MM-DD') === eventDate
      ) {
        format = `昨天 ${format}`;
      } else if (
        this.$moment(today).subtract(2, 'days').format('YYYY-MM-DD') === eventDate
      ) {
        format = `前天 ${format}`;
      }
      return H_time.getDateDashFormat(date, format);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/dot-remind-content";
</style>